import React from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full py-10 px-6 md:px-10 lg:px-20 bg-[#111] border-t border-gray-800" data-id="element-82">
      <div className="max-w-6xl mx-auto" data-id="element-83">
        <div className="flex flex-col md:flex-row justify-between mb-8" data-id="element-84">
          <div className="text-xl font-bold tracking-wider mb-6 md:mb-0" data-id="element-85">
            <span className="text-[#00E0FF]" data-id="element-86">CRITICAL</span>
            <span className="ml-2" data-id="element-87">VOICE</span>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-88">
            <div className="flex flex-wrap gap-8" data-id="element-89">
              <a href="#" className="text-gray-400 hover:text-[#00E0FF] transition-colors" data-id="element-90">
                About
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E0FF] transition-colors" data-id="element-91">
                Use Cases
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E0FF] transition-colors" data-id="element-92">
                Pricing
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E0FF] transition-colors" data-id="element-93">
                Blog
              </a>
              <a href="#" className="text-gray-400 hover:text-[#00E0FF] transition-colors" data-id="element-94">
                Contact
              </a>
            </div>
            <div className="mt-6 md:mt-0" data-id="element-95">
              <h3 className="text-[#00E0FF] font-semibold mb-4" data-id="element-96">Contact Us</h3>
              <div className="space-y-3" data-id="element-97">
                <a href="mailto:info@criticalfuture.com" className="flex items-center text-gray-400 hover:text-[#00E0FF] transition-colors" data-id="element-98">
                  <MailIcon className="w-4 h-4 mr-2" data-id="element-99" />
                  info@criticalfuture.com
                </a>
                <a href="tel:+447366319902" className="flex items-center text-gray-400 hover:text-[#00E0FF] transition-colors" data-id="element-100">
                  <PhoneIcon className="w-4 h-4 mr-2" data-id="element-101" />
                  +44 736 631 9902
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center" data-id="element-102">
          <p className="text-gray-400 text-sm mb-4 md:mb-0" data-id="element-103">
            © {new Date().getFullYear()} Critical Future Global. All rights
            reserved.
          </p>
          <div className="flex gap-6" data-id="element-104">
            <a href="#" className="text-gray-400 hover:text-[#00E0FF] transition-colors text-sm" data-id="element-105">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-400 hover:text-[#00E0FF] transition-colors text-sm" data-id="element-106">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}